import React, { useMemo } from 'react';
import { AutoFields, EditView, LinkButton } from '@builtbypixel/nucleus';
import { Button, Box, Flex } from '@builtbypixel/plasma';
import { useParams } from 'react-router-dom';
import { useFormContext, useWatch } from 'react-hook-form';
import setup from './setup';
import AddressSearch from '../../components/AddressFinder';
import GoogleMapReact from 'google-map-react';
import MosqueSubscription from './MosqueSubscription';

const ProfileButton = () => {
    const { watch } = useFormContext();
    const profile = watch('mosque_details.slug');

    return (
        <Box w='100%' p='20px'>
            <Button
                as='a'
                href={`${process.env.REACT_APP_FRONTEND_URL}/mosques/${profile}`}
                variantColor='primary'
                target='_blank'
            >
                View Mosque Profile
            </Button>
        </Box>
    );
};

const EditForm = () => {
    const { type } = useParams();
    const fields = useMemo(
        () => [
            {
                group: 'Mosque Details',
                tab: 'General',
                fields: [
                    {
                        name: 'mosque_details.name',
                        component: 'text',
                        placeholder: 'Mosque Name',
                        label: 'Mosque Name',
                        isRequired: true,
                        rules: { required: true },
                    },
                    {
                        name: 'mosque_details.mosque_email',
                        component: 'text',
                        type: 'email',
                        placeholder: 'Mosque Email',
                        label: 'Mosque Email',
                        isRequired: true,
                        rules: { required: true, email: true },
                    },
                    {
                        name: 'mosque_details.phone_number',
                        component: 'text',
                        type: 'number',
                        placeholder: 'Phone Number',
                        label: 'Phone Number',
                    },
                    {
                        name: 'master_mosque',
                        component: 'switch',
                        placeholder: 'Is Master Mosque?',
                        label: 'Is Master Mosque?',
                        size: 'lg',
                    },
                ],
            },
            {
                group: 'Mosque Location',
                tab: 'General',
                fields: [
                    {
                        name: 'location.lat',
                        component: 'text',
                        placeholder: 'Latitude',
                        label: 'Latitude',
                        isRequired: true,
                        rules: { required: true },
                    },
                    {
                        name: 'location.lng',
                        component: 'text',

                        placeholder: 'Longitude',
                        label: 'Longitude',
                        isRequired: true,
                        rules: { required: true, email: true },
                    },
                    {
                        name: 'address',
                        component: AddressSearch,

                        placeholder: 'Address',
                        label: 'Address',
                    },
                    {
                        name: 'map',
                        component: Map,

                        label: 'Map',
                    },
                ],
            },
            {
                group: 'Mosque Subscription',
                tab: 'Subscription',
                fields: [
                    {
                        name: 'subscription',
                        component: MosqueSubscription,
                    },
                ],
            },
        ],
        []
    );
    return (
        <EditView setup={setup}>
            {type === 'edit' && (
                <Flex>
                    <ProfileButton />
                </Flex>
            )}
            <AutoFields fields={fields} />
        </EditView>
    );
};

const Map = () => {
    const lat = useWatch({ name: 'location.lat' });
    const lng = useWatch({ name: 'location.lng' });
    return (
        <Box w='100%' maxWidth='700px' position='relative'>
            <GoogleMapReact
                center={{ lat, lng }}
                defaultZoom={13}
                yesIWantToUseGoogleMapApiInternals
                style={{ height: 300 }}
            >
                {lat && lng && <Marker lat={lat} lng={lng}></Marker>}
            </GoogleMapReact>
        </Box>
    );
};

const Marker = (props) => (
    <div
        alt={props.text}
        style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '30px',
            height: '30px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#000',
            border: '2px solid #fff',
            borderRadius: '100%',
            userSelect: 'none',
            transform: 'translate(-50%, -50%)',
        }}
        {...(props.onClick ? { onClick: props.onClick } : {})}
    >
        {props.children}
    </div>
);

export default EditForm;
